<div class="window-header">
  <div class="header-title">
    {{ (slidingWindowOptions$ | async)?.title }}
  </div>
  <app-close-button (closeClicked)="closeButtonClicked.emit()" />
</div>
